import UserService from '@/services/UserService';
export default {
  name: 'FAQ',
  data() {
    return {
      networkInfo: null,
      groupnum: 1,
      monthlyfee: null,
      yearlyfee: null,
      eventfee: null,
      duration: null,
      faqGroup2: [{
        title: 'ONCE I UPLOAD A VIDEO TO SPiN, WHO OWNS THE CONTENT?',
        text: 'SPiN does not acquire or retain ownership of uploaded video. Content is owned by the organization or production company that uploads it.'
      }, {
        title: 'CAN I UPLOAD A VIDEO THAT CONTAINS A MASTER RECORDING?',
        text: 'Not at this time, because use of a master recording requires an additional license.'
      }, {
        title: 'ARE VIDEOS OF CHEER, DANCE AND WINTERGUARD PERFORMANCES ALLOWED TO BE POSTED ON THE SITE?',
        text: 'Not at this time. Any performance involving a master recording is currently prohibited.'
      }, {
        title: 'WHO IS ABLE TO UPLOAD VIDEOS?',
        text: 'Professional videographers, production companies, organization channel administrators, and ensemble directors.'
      }, {
        title: 'IS THERE AN APPROVAL PROCESS ONCE VIDEOS ARE UPLOADED?',
        text: 'Once a video is uploaded and the compositions have been cleared by publishers, it becomes viewable. Uploaders may also choose to make videos public or private.'
      }, {
        title: 'WHAT VIDEO FORMATS CAN BE UPLOADED?',
        text: 'Most video formats and codecs are supported. Contact us if your video is incompatible.'
      }, {
        title: 'ARE THERE VIDEO SIZE LIMITATIONS?',
        text: 'There is no strict size restriction, but videos should generally be one composition per video.'
      }, {
        title: 'IF I LIVE STREAM AN EVENT ON BEHALF OF A CHANNEL, WILL A VIDEO OF THAT EVENT AUTOMATICALLY BECOME AVAILABLE ON SPiN?',
        text: 'No. You must upload a video of the live stream separately in order to list composition and ensemble information.'
      }],
      faqGroup3: [{
        title: 'IF MY SCHOOL SIGNS UP FOR A FREE SPiN CHANNEL, DO THE DIRECTORS OF ALL OF OUR ENSEMBLES HAVE FULL ADMINISTRATIVE RIGHTS?',
        text: 'No. Each organization has one dedicated Channel Administrator. Directors are given their own access to log in, upload, and view videos associated with their school channel.'
      }, {
        title: 'WHO IS ABLE TO UPLOAD VIDEOS?',
        text: 'Professional videographers, production companies, organization channel administrators, and ensemble directors.'
      }, {
        title: 'WHAT VIDEO FORMATS CAN BE UPLOADED?',
        text: 'Most video formats and codecs are supported. Contact us if your video is incompatible.'
      }, {
        title: 'ARE THERE VIDEO SIZE LIMITATIONS?',
        text: 'There is no strict size restriction, but videos should generally be one composition per video.'
      }, {
        title: 'IF I AM THE HOST OF AN EVENT, CAN I UPLOAD VIDEOS OF ALL OF THE PERFORMING ENSEMBLES?',
        text: 'Yes. If you host the event, you can upload videos of all performing ensembles whether they have a SPiN channel or not.'
      }, {
        title: 'WHY AM I BEING ASKED TO UPLOAD A PICTURE OR LOGO OF MY ORGANIZATION WHEN I CREATE MY CHANNEL?',
        text: 'This is optional. It adds a personalized touch to your channel and can be changed any time.'
      }, {
        title: 'AM I ABLE TO ADD AND/OR DELETE MY VIDEOS AT MY DISCRETION?',
        text: 'Yes. The Channel Administrator can add or delete videos at any time.'
      }, {
        title: 'ONCE I UPLOAD A VIDEO TO SPiN, WHO OWNS THE CONTENT?',
        text: 'SPiN does not retain ownership. The organization that uploaded the video owns the content.'
      }, {
        title: 'WHY DO SOME VIDEOS TAKE LONGER TO CLEAR THAN OTHERS?',
        text: 'Some publishers take longer than others to clear songs, so approval timing can vary.'
      }, {
        title: 'ARE THERE LIMITS TO HOW MANY ENSEMBLES CAN BE ASSOCIATED WITH ONE ORGANIZATION?',
        text: 'No. Schools and music education associations are encouraged to include all performing ensembles.'
      }, {
        title: 'IF I LIVE STREAM AN EVENT ON MY CHANNEL, WILL A VIDEO OF THAT EVENT AUTOMATICALLY BECOME AVAILABLE?',
        text: 'No. You will need to upload a video of the live stream separately.'
      }],
      faqGroup4: [{
        title: 'IF MY ORGANIZATION SIGNS UP FOR A FREE SPiN CHANNEL, DO THE DIRECTORS OF ALL OF OUR PARTICIPATING ENSEMBLES GET A SUBSCRIPTION?',
        text: 'Yes. Music Education Association channels have one dedicated administrator and can designate additional administrative users. Participating ensemble directors also receive viewing access.'
      }, {
        title: 'WHO IS ABLE TO UPLOAD VIDEOS?',
        text: 'Professional videographers, production companies, organization channel administrators, and ensemble directors.'
      }, {
        title: 'WHAT VIDEO FORMATS CAN BE UPLOADED?',
        text: 'Most video formats and codecs are supported. Contact us if your video is incompatible.'
      }, {
        title: 'ARE THERE VIDEO SIZE LIMITATIONS?',
        text: 'There is no strict size restriction, but videos should generally be one composition per video.'
      }, {
        title: 'IF I AM THE HOST OF AN EVENT, CAN I UPLOAD VIDEOS OF ALL OF THE PERFORMING ENSEMBLES?',
        text: 'Yes. If you host the event, you can upload videos of all performing ensembles whether they have a SPiN channel or not.'
      }, {
        title: 'WHY AM I BEING ASKED TO UPLOAD A PICTURE OR LOGO OF MY ORGANIZATION WHEN I CREATE MY CHANNEL?',
        text: 'This is optional. It adds a personalized touch to your channel and can be changed any time.'
      }, {
        title: 'AM I ABLE TO ADD AND/OR DELETE MY VIDEOS AT MY DISCRETION?',
        text: 'Yes. The Channel Administrator can add or delete videos at any time.'
      }, {
        title: 'ONCE I UPLOAD A VIDEO TO SPiN, WHO OWNS THE CONTENT?',
        text: 'SPiN does not retain ownership. The organization that uploaded the video owns the content.'
      }, {
        title: 'WHY DO SOME VIDEOS TAKE LONGER TO CLEAR THAN OTHERS?',
        text: 'Some publishers take longer than others to clear songs, so approval timing can vary.'
      }, {
        title: 'ARE THERE LIMITS TO HOW MANY ENSEMBLES CAN BE ASSOCIATED WITH ONE ORGANIZATION?',
        text: 'No. Schools and music education associations are encouraged to include all performing ensembles.'
      }, {
        title: 'IF I LIVE STREAM AN EVENT ON MY CHANNEL, WILL A VIDEO OF THAT EVENT AUTOMATICALLY BECOME AVAILABLE?',
        text: 'No. You will need to upload a video of the live stream separately.'
      }]
    };
  },
  async mounted() {
    await this.getNetworkInfo();
    this.monthlyfee = this.networkInfo.subscriptiontypes[1].amount;
    this.yearlyfee = this.networkInfo.subscriptiontypes[0].amount;
    this.eventfee = this.networkInfo.subscriptiontypes[2].amount;
    this.duration = this.networkInfo.subscriptiontypes[2].durationdays;
    if (this.networkInfo.groupnum) {
      this.groupnum = this.networkInfo.groupnum;
    }
  },
  methods: {
    async getNetworkInfo() {
      this.networkInfo = await UserService.getNetworkInfo();
    }
  }
};